import { TransactionStatus } from 'dashboard/models/transaction-status';
import Action from 'lib/interfaces/Action';

export type TransactionStatusesActions =
  | Action<
      TransactionStatusesActionType.AppendTransactionStatuses,
      AppendTransactionStatusesPayload
    >
  | Action<TransactionStatusesActionType.SetTransactionStatuses, SetTransactionStatusesPayload>
  | Action<TransactionStatusesActionType.UpdateTransactionStatus, UpdateTransactionStatusPayload>;

export enum TransactionStatusesActionType {
  AppendTransactionStatuses = 'transaction-statuses/APPEND_TRANSACTION_STATUSES',
  SetTransactionStatuses = 'transaction-statuses/SET_TRANSACTION_STATUSES',
  UpdateTransactionStatus = 'transaction-statuses/UPDATE_TRANSACTION_STATUS',
}

interface AppendTransactionStatusesPayload {
  transactionStatuses: TransactionStatus[];
}

export function appendTransactionStatuses(
  transactionStatuses: TransactionStatus[],
): Action<
  TransactionStatusesActionType.AppendTransactionStatuses,
  AppendTransactionStatusesPayload
> {
  return {
    payload: {
      transactionStatuses,
    },
    type: TransactionStatusesActionType.AppendTransactionStatuses,
  };
}

interface SetTransactionStatusesPayload {
  transactionStatuses: TransactionStatus[];
}

export function setTransactionStatuses(
  transactionStatuses: TransactionStatus[],
): Action<TransactionStatusesActionType.SetTransactionStatuses, SetTransactionStatusesPayload> {
  return {
    payload: {
      transactionStatuses,
    },
    type: TransactionStatusesActionType.SetTransactionStatuses,
  };
}

interface UpdateTransactionStatusPayload {
  transactionStatus: TransactionStatus;
}

export function updateTransactionStatus(
  transactionStatus: TransactionStatus,
): Action<TransactionStatusesActionType.UpdateTransactionStatus, UpdateTransactionStatusPayload> {
  return {
    payload: {
      transactionStatus,
    },
    type: TransactionStatusesActionType.UpdateTransactionStatus,
  };
}
